import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import api, { resolveImg } from "../lib/api";

export default function Perfumer() {
  const { t, lang, loc } = useLang();
  const [content, setContent] = useState({});
  useEffect(() => { api.get("/content").then((r) => setContent(r.data)).catch(() => {}); }, []);

  const name = loc(content, "perfumer_name") || "OMR PERFUMER";
  const intro = content[`perfumer_${lang}`] || "";
  const bio = content[`perfumer_bio_${lang}`] || "";
  const bioParas = bio.split(/\n\n+/).filter(Boolean);
  const portrait = content.perfumer_portrait || "/images/perfumer-portrait.webp";

  return (
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        <div className="order-2 lg:order-1">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C49A6C] mb-6">{t("nav_perfumer")}</p>
          <h1 className="serif text-4xl md:text-6xl leading-tight">{name}</h1>
          <p className="text-sm uppercase tracking-[0.2em] text-[#8A857D] mt-4">{t("perfumer_role")}</p>

          {intro && (
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="serif text-2xl md:text-3xl leading-[1.6] text-[#F2EBE1] mt-10"
            >
              {intro}
            </motion.p>
          )}

          <div className="mt-8 space-y-5">
            {bioParas.map((p, i) => (
              <p key={p} className="text-[#8A857D] leading-[1.9]">{p}</p>
            ))}
          </div>

          <Link to="/shop" className="inline-block mt-12 text-xs uppercase tracking-[0.2em] text-[#F2EBE1] link-underline">
            {t("shop_fragrances")} →
          </Link>
        </div>

        <div className="order-1 lg:order-2 lg:sticky lg:top-24">
          <div className="aspect-[4/5] bg-[#141311] border border-[#262421] flex items-center justify-center overflow-hidden" data-testid="perfumer-portrait">
            {portrait ? (
              <img src={resolveImg(portrait)} alt={name} className="w-full h-full object-cover" />
            ) : (
              <div className="text-center px-8">
                <span className="serif text-5xl text-[#6E685F]">OMR</span>
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#6E685F] mt-4">{lang === "ar" ? "صورة صانع العطر قريباً" : "Founder portrait — coming soon"}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
